import React from 'react';
import PropTypes from 'prop-types';
import { useIntl, defineMessages } from 'react-intl';
import { UniversalLink, ConditionalLink } from '@plone/volto/components';
import { Button } from 'design-react-kit';
import { flattenToAppURL } from '@plone/volto/helpers';
import { v4 as uuid } from 'uuid';

/* STYLE */
import '@redturtle/volto-io-prenoto/components/Blocks/BookingButton/BookingButton.scss';

const messages = defineMessages({
  label_default_booking_button: {
    id: 'Prenota appuntamento',
    defaultMessage: 'Prenota appuntamento',
  },
});

const Body = (props) => {
  const { data, isEditMode } = props;
  const intl = useIntl();

  return (
    <Button
      color="primary"
      className={isEditMode && 'isEditMode'}
      outline
      tag={UniversalLink}
      data-element="service-booking-access"
      href={
        isEditMode
          ? '#'
          : flattenToAppURL(
              `/prenotazione-appuntamenti-uffici?${new URLSearchParams({
                uid: props.properties.UID,
                booking_type: data.booking_type || '',
              })}`,
            )
      }
    >
      {data.title ?? intl.formatMessage(messages.label_default_booking_button)}
    </Button>
  );
};

export default Body;
